module.exports = __webpack_public_path__ + "static/img/zhuanlizhuanrang.d700b4e6.png";